import {
  type FeedbackOptionCategory,
  OrderListFeedbackContextProvider,
  type UserData,
} from "~/features/orders/orderDetails/hooks/useSendOrderFeedback/components/OrderListFeedbackContext";
import { OrderListPage } from "~/features/orders/orderList/OrderListPage";
import { MultiAccountSearchDataProvider } from "~/features/orders/orderList/components/OrderListSearchBox/MultiAccountSelect/MultiAccountSearchDataProvider";
import { OrderListDesignToggleProvider } from "../common/components/NewDesignToggle";

export function create(data: {
  userData: UserData;
  orderFeedbackOptions: FeedbackOptionCategory[];
  accounts: string;
  filters: string;
}) {
  return (
    <OrderListFeedbackContextProvider
      value={{ userData: data.userData, orderFeedbackOptions: data.orderFeedbackOptions }}
    >
      <MultiAccountSearchDataProvider accountsJson={data.accounts}>
        <OrderListDesignToggleProvider>
          <OrderListPage />
        </OrderListDesignToggleProvider>
      </MultiAccountSearchDataProvider>
    </OrderListFeedbackContextProvider>
  );
}
